'use client';

import { useState } from 'react';
import Image from 'next/image';
import { X } from 'lucide-react';

export default function TransformationModal({ data, onClose }) {
  const [mainImage, setMainImage] = useState(data.images[0]);

  return (
    // 1. Container: Fixed overlay with scroll capability for small screens
    <div className="fixed inset-0 bg-black/90 backdrop-blur-sm z-[70] overflow-y-auto">
      
      {/* 2. Wrapper: Centers content and handles minimum height */}
      <div className="min-h-full flex items-center justify-center p-4 md:p-8">
        
        {/* Close Button: Fixed to screen corner so it's always accessible */}
        <button
          onClick={onClose}
          className="fixed top-4 right-4 md:top-6 md:right-6 z-[80] p-2 md:p-3 bg-black/50 hover:bg-[#faaf40]/80 rounded-full text-white transition-all backdrop-blur-md"
        >
          <X size={24} className="md:w-7 md:h-7" />
        </button>

        {/* 3. Main Content Card */}
        <div className="relative w-full max-w-5xl flex flex-col items-center gap-6 md:gap-8 mt-8 md:mt-0">
          
          {/* Top Section: Image & Thumbnails */}
          <div className="flex flex-col md:flex-row gap-4 w-full justify-center items-center md:items-start">
            
            {/* THUMBNAILS: Horizontal row on mobile, Vertical column on Desktop */}
            <div className="order-2 md:order-1 flex md:flex-col gap-3 overflow-x-auto md:overflow-y-auto max-w-full md:max-h-[600px] p-1 scrollbar-hide">
              {data.images.map((img, idx) => (
                <div
                  key={idx}
                  // Responsive sizing: smaller on mobile, larger on desktop
                  className={`relative flex-shrink-0 w-16 h-16 md:w-24 md:h-24 rounded-md overflow-hidden border cursor-pointer transition-all ${
                    mainImage === img
                      ? 'border-[#faaf40] ring-1 ring-[#faaf40]'
                      : 'border-transparent hover:border-[#faaf40]/50'
                  }`}
                  onMouseEnter={() => setMainImage(img)}
                  onClick={() => setMainImage(img)} // crucial for mobile
                >
                  <Image
                    src={img}
                    alt={`thumb-${idx}`}
                    fill
                    className="object-cover"
                  />
                </div>
              ))}
            </div>

            {/* MAIN IMAGE */}
            <div className="order-1 md:order-2 relative w-full md:w-[500px] lg:w-[600px] aspect-[3/4] md:h-[600px] rounded-xl overflow-hidden bg-[#0f0f0f] shadow-2xl border border-white/10">
              <Image
                src={mainImage}
                alt={`${data.name} main`}
                fill
                className="object-cover transition-all duration-500"
                priority
              />
            </div>
          </div>

          {/* DESCRIPTION */}
          <div className="text-center max-w-2xl px-2 pb-8 md:pb-0">
            <h2 className="text-2xl md:text-3xl font-bold text-[#faaf40]">
              {data.name}
            </h2>
            <p className="uppercase text-xs md:text-sm tracking-widest text-[#faaf40]/80 mt-1">
              {data.title}
            </p>
            <p className="text-gray-300 mt-4 text-sm md:text-base leading-relaxed">
              {data.desc}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}